// import external dependencies
import 'jquery';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import 'slick-carousel/slick/slick.min';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,

  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Detect and Remove Date Picker Autofill
$('.gfield .datepicker').each(function () {
  $(this).attr('autocomplete', 'off');
});


// Show/hide search overlay
$('.menu-item-search a').click(function(e) {
  e.preventDefault();
  $('.search-overlay').fadeIn().css('display', 'flex');
});

$('.search-overlay button.search-close').click(function() {
  $('.search-overlay').fadeOut();
});

const disclaimerBanner = document.querySelector('.disclaimer-banner');
const disclaimerClose = document.querySelector('.disclaimer-close');

if(disclaimerClose) {
  disclaimerClose.addEventListener('click', () => {
    disclaimerBanner.style.display = 'none';
  });
}

// jQuery(document).ready(() => {
//   const wpadminbar            = $('#wpadminbar'),
//     bodyTag                   = $(document.body),
//     headerComponentB          = $('.header-component-b'),
//     headerBranding            = $('.header__branding'),
//     jsButtonNavControl        = $('.nav-control'),
//     headerBrandingPositionTop = parseInt(headerBranding.css('--logo-position-top-mobile'));
//
//   if(headerComponentB.length > 0) {
//     if(wpadminbar.length > 0 && jsButtonNavControl.length > 0) {
//       jsButtonNavControl.on('click', function() {
//         if(bodyTag.hasClass('nav-is-open')) {
//           headerBranding.css('top', wpadminbar.height() + headerBrandingPositionTop + 'px');
//         }
//       });
//     }
//   }
// });



// WEBPACK FOOTER //
// ./scripts/main.js